import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import {
  Pencil, X, Save, Loader2, History, ChevronDown,
  ChevronUp, Clock, AlertCircle, RefreshCw, Brain
} from 'lucide-react';
import { MUNICIPIOS, AREAS } from '../../utils/cidades';

const AREAS_LIST = typeof AREAS !== 'undefined' ? AREAS : [
  'Tecnologia da Informação','Administração e Gestão','Saúde e Enfermagem',
  'Educação e Ensino','Comércio e Vendas','Engenharia e Construção',
  'Agronegócio','Direito e Jurídico','Contabilidade e Finanças',
  'Comunicação e Marketing','Logística e Transporte','Serviços Gerais',
];

const HARD_SKILLS_LISTA = [
  'Excel / Google Sheets','Word / Google Docs','PowerPoint','Sistema ERP','Sistema CRM',
  'Programação Python','Programação JavaScript','SQL / Banco de dados','Power BI','Análise de dados',
  'Gestão de equipes','Contabilidade','Atendimento ao cliente','Redes de computadores','Suporte técnico',
  'Inglês','Espanhol','Direção veicular','Operação de máquinas','Pacote Office',
];

const CURSOS_LISTA = [
  'Curso de Atendente de Farmácia','Técnico em Enfermagem','Técnico em Radiologia',
  'Auxiliar de Saúde Bucal','Técnico em Informática','Técnico em Redes',
  'Certificação CompTIA A+','Licenciatura na área','OAB ativa','CRC ativo',
  'CREA ativo','Técnico em Edificações','Técnico em Segurança do Trabalho',
  'NR-35','NR-10','NR-12','CNH categoria A','CNH categoria B','CNH categoria C',
  'CNH categoria D','CNH categoria E','CPA-10','CPA-20',
];

// ── Modal de edição da vaga (completo com pré-requisitos) ────
function ModalEditar({ vaga, onSalvar, onFechar, salvando }) {
  const [form, setForm] = useState({
    titulo:             vaga.titulo || '',
    descricao:          vaga.descricao || '',
    quantidade:         vaga.quantidade || 1,
    cidade_vaga:        vaga.cidade_vaga || '',
    areas_contratacao:  vaga.areas_contratacao || [],
    nivel_escolaridade: vaga.nivel_escolaridade || '',
    salario_min:        vaga.salario_min || '',
    salario_max:        vaga.salario_max || '',
    beneficios:         vaga.beneficios || '',
    modalidade:         vaga.modalidade || 'presencial',
    regime_contratacao: vaga.regime_contratacao || 'clt',
    status:             vaga.status || 'aberta',
    // Pré-requisitos
    req_escolaridade:   vaga.req_escolaridade || '',
    req_experiencia:    vaga.req_experiencia || 0,
    req_hard_skills:    vaga.req_hard_skills || [],
    req_soft_skills:    vaga.req_soft_skills || [],
    req_idiomas:        vaga.req_idiomas || [],
    req_cursos:         vaga.req_cursos || [],
    req_certificacoes:  vaga.req_certificacoes || '',
    req_descricao:      vaga.req_descricao || '',
  });
  const [novaSkill, setNovaSkill] = useState('');
  const [novoCurso, setNovoCurso] = useState('');
  const [abaReq,    setAbaReq]    = useState(false); // toggle seção pré-requisitos

  const toggleArea  = a => setForm(p => ({ ...p, areas_contratacao: p.areas_contratacao.includes(a) ? p.areas_contratacao.filter(x=>x!==a) : [...p.areas_contratacao,a] }));
  const toggleSkill = s => setForm(p => ({ ...p, req_hard_skills:   p.req_hard_skills.includes(s)   ? p.req_hard_skills.filter(x=>x!==s)   : [...p.req_hard_skills,s]   }));
  const toggleCurso = c2=> setForm(p => ({ ...p, req_cursos:        p.req_cursos.includes(c2)       ? p.req_cursos.filter(x=>x!==c2)       : [...p.req_cursos,c2]       }));
  const toggleIdioma= i => setForm(p => ({ ...p, req_idiomas:       p.req_idiomas.includes(i)       ? p.req_idiomas.filter(x=>x!==i)       : [...p.req_idiomas,i]       }));
  const toggleSoft  = s => setForm(p => ({ ...p, req_soft_skills:   p.req_soft_skills.includes(s)   ? p.req_soft_skills.filter(x=>x!==s)   : [...p.req_soft_skills,s]   }));

  const addSkill = () => { const s=novaSkill.trim(); if(s&&!form.req_hard_skills.includes(s)){setForm(p=>({...p,req_hard_skills:[...p.req_hard_skills,s]}));setNovaSkill('');} };
  const addCurso = () => { const c2=novoCurso.trim(); if(c2&&!form.req_cursos.includes(c2)){setForm(p=>({...p,req_cursos:[...p.req_cursos,c2]}));setNovoCurso('');} };

  const c = (k) => ({ value: form[k]??'', onChange: e => setForm(p => ({...p, [k]: e.target.value})) });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-gradient-to-r from-acre-dark to-acre-green p-5 rounded-t-2xl flex items-center justify-between z-10">
          <div>
            <p className="font-sora font-bold text-white">Editar Vaga</p>
            <p className="text-white/60 text-xs truncate max-w-xs">{vaga.titulo}</p>
          </div>
          <button onClick={onFechar} className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center">
            <X size={14} className="text-white"/>
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <label className="label">Título da vaga *</label>
              <input className="input" {...c('titulo')} placeholder="Ex: Analista de TI"/>
            </div>
            <div className="col-span-2">
              <label className="label">Descrição</label>
              <textarea className="input min-h-24 resize-none" {...c('descricao')} placeholder="Descreva as responsabilidades..."/>
            </div>
            <div>
              <label className="label">Cidade *</label>
              <select className="input" {...c('cidade_vaga')}>
                <option value="">Selecione...</option>
                {MUNICIPIOS.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
            <div>
              <label className="label">Nº de vagas</label>
              <input className="input" type="number" min="1" {...c('quantidade')}/>
            </div>
            <div>
              <label className="label">Salário mínimo</label>
              <input className="input" type="number" {...c('salario_min')} placeholder="R$ 0,00"/>
            </div>
            <div>
              <label className="label">Salário máximo</label>
              <input className="input" type="number" {...c('salario_max')} placeholder="R$ 0,00"/>
            </div>
            <div>
              <label className="label">Modalidade</label>
              <select className="input" {...c('modalidade')}>
                {['presencial','remoto','hibrido'].map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
            <div>
              <label className="label">Regime</label>
              <select className="input" {...c('regime_contratacao')}>
                {['clt','pj','estagio','temporario','autonomo'].map(r => <option key={r} value={r}>{r.toUpperCase()}</option>)}
              </select>
            </div>
            <div>
              <label className="label">Escolaridade mínima</label>
              <select className="input" {...c('nivel_escolaridade')}>
                <option value="">Sem requisito</option>
                {['Ensino Fundamental','Ensino Médio','Técnico','Graduação','Pós-graduação'].map(n => (
                  <option key={n} value={n}>{n}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">Status</label>
              <select className="input" {...c('status')}>
                <option value="aberta">Aberta</option>
                <option value="pausada">Pausada</option>
                <option value="fechada">Fechada</option>
              </select>
            </div>
            <div className="col-span-2">
              <label className="label">Benefícios</label>
              <input className="input" {...c('beneficios')} placeholder="Vale refeição, plano de saúde..."/>
            </div>
          </div>

          {/* Áreas de contratação */}
          <div>
            <label className="label">Áreas de contratação *</label>
            <div className="flex flex-wrap gap-1.5">
              {AREAS_LIST.map(area => (
                <button key={area} type="button" onClick={() => toggleArea(area)}
                  className={`text-xs px-2.5 py-1 rounded-full border font-medium transition-all ${
                    form.areas_contratacao.includes(area)
                      ? 'bg-acre-green text-white border-acre-green'
                      : 'bg-white text-gray-500 border-gray-200 hover:border-acre-green'
                  }`}>
                  {area}
                </button>
              ))}
            </div>
          </div>

          {/* ── PRÉ-REQUISITOS (toggle expansível) ── */}
          <div className="border border-blue-200 rounded-2xl overflow-hidden">
            <button type="button" onClick={() => setAbaReq(a => !a)}
              className="w-full flex items-center justify-between px-4 py-3 bg-blue-50 hover:bg-blue-100 transition-colors text-left">
              <div className="flex items-center gap-2">
                <Brain size={15} className="text-blue-600"/>
                <p className="font-sora font-bold text-sm text-blue-800">Pré-Requisitos da Vaga</p>
                <span className="text-xs text-blue-500">
                  ({[form.req_escolaridade, form.req_hard_skills?.length, form.req_cursos?.length].filter(Boolean).length > 0
                    ? `${[form.req_hard_skills?.length||0, form.req_cursos?.length||0].reduce((a,b)=>a+b,0)} requisitos`
                    : 'nenhum definido'})
                </span>
              </div>
              {abaReq ? <ChevronUp size={14} className="text-blue-500"/> : <ChevronDown size={14} className="text-blue-500"/>}
            </button>

            {abaReq && (
              <div className="p-4 space-y-4 border-t border-blue-100">
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="label text-xs">Escolaridade mínima <span className="text-blue-500">(15% score)</span></label>
                    <select className="input text-sm" {...c('req_escolaridade')}>
                      <option value="">Sem requisito</option>
                      {['Ensino Fundamental','Ensino Médio','Técnico','Graduação','Pós-graduação','Mestrado'].map(n=><option key={n}>{n}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="label text-xs">Experiência mínima <span className="text-blue-500">(15% score)</span></label>
                    <select className="input text-sm" value={form.req_experiencia} onChange={e=>setForm(p=>({...p,req_experiencia:Number(e.target.value)}))}>
                      <option value="0">Sem requisito</option>
                      <option value="1">6 meses – 1 ano</option>
                      <option value="2">1 – 2 anos</option>
                      <option value="3">2 – 3 anos</option>
                      <option value="5">3 – 5 anos</option>
                      <option value="7">5+ anos</option>
                    </select>
                  </div>
                </div>

                {/* Cursos obrigatórios */}
                <div>
                  <label className="label text-xs">Cursos e Certificações Obrigatórias <span className="text-red-400">(excluem candidatos sem esses cursos)</span></label>
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    {CURSOS_LISTA.map(c2 => (
                      <button key={c2} type="button" onClick={() => toggleCurso(c2)}
                        className={`text-xs px-2 py-0.5 rounded-full border transition-all ${form.req_cursos?.includes(c2) ? 'bg-orange-500 text-white border-orange-500' : 'bg-white text-gray-500 border-gray-200 hover:border-orange-400'}`}>
                        {c2}
                      </button>
                    ))}
                  </div>
                  <div className="flex gap-2">
                    <input className="input text-xs flex-1" placeholder="Curso específico..." value={novoCurso}
                      onChange={e=>setNovoCurso(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault();addCurso();}}}/>
                    <button type="button" onClick={addCurso} className="btn-outline text-xs px-3">+</button>
                  </div>
                  {form.req_cursos?.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-1.5">
                      {form.req_cursos.map(c2 => (
                        <span key={c2} className="inline-flex items-center gap-1 text-xs bg-orange-100 text-orange-700 border border-orange-200 px-2 py-0.5 rounded-full">
                          📋 {c2}
                          <button type="button" onClick={()=>toggleCurso(c2)} className="hover:text-red-600">×</button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {/* Hard Skills */}
                <div>
                  <label className="label text-xs">Hard Skills requeridas <span className="text-blue-500">(20% score)</span></label>
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    {HARD_SKILLS_LISTA.map(s => (
                      <button key={s} type="button" onClick={() => toggleSkill(s)}
                        className={`text-xs px-2 py-0.5 rounded-full border transition-all ${form.req_hard_skills?.includes(s) ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-500 border-gray-200 hover:border-blue-400'}`}>
                        {s}
                      </button>
                    ))}
                  </div>
                  <div className="flex gap-2">
                    <input className="input text-xs flex-1" placeholder="Outra habilidade técnica..." value={novaSkill}
                      onChange={e=>setNovaSkill(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault();addSkill();}}}/>
                    <button type="button" onClick={addSkill} className="btn-outline text-xs px-3">+</button>
                  </div>
                  {form.req_hard_skills?.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-1.5">
                      {form.req_hard_skills.map(s => (
                        <span key={s} className="inline-flex items-center gap-1 text-xs bg-blue-100 text-blue-700 border border-blue-200 px-2 py-0.5 rounded-full">
                          {s}<button type="button" onClick={()=>toggleSkill(s)} className="hover:text-red-600">×</button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                {/* Soft Skills */}
                <div>
                  <label className="label text-xs">Soft Skills desejadas</label>
                  <div className="flex flex-wrap gap-1.5">
                    {['Liderança','Trabalho em equipe','Comunicação assertiva','Proatividade','Gestão do tempo','Criatividade','Atenção aos detalhes','Resiliência','Adaptabilidade'].map(s => (
                      <button key={s} type="button" onClick={() => toggleSoft(s)}
                        className={`text-xs px-2 py-0.5 rounded-full border transition-all ${form.req_soft_skills?.includes(s) ? 'bg-purple-600 text-white border-purple-600' : 'bg-white text-gray-500 border-gray-200 hover:border-purple-400'}`}>
                        {s}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Idiomas */}
                <div>
                  <label className="label text-xs">Idiomas necessários</label>
                  <div className="flex flex-wrap gap-1.5">
                    {['Inglês','Espanhol','Francês','Italiano','Alemão'].map(i => (
                      <button key={i} type="button" onClick={() => toggleIdioma(i)}
                        className={`text-xs px-2 py-0.5 rounded-full border transition-all ${form.req_idiomas?.includes(i) ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-white text-gray-500 border-gray-200 hover:border-emerald-400'}`}>
                        {i}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Descrição dos requisitos */}
                <div>
                  <label className="label text-xs">Descrição adicional dos requisitos</label>
                  <textarea className="input text-xs resize-none" rows={2}
                    placeholder="Ex: Para atendente de farmácia é necessário o curso reconhecido pelo CRF. Para TI, aceita cursos similares..."
                    {...c('req_descricao')}/>
                </div>
              </div>
            )}
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-3 flex items-start gap-2 text-xs text-yellow-700">
            <AlertCircle size={13} className="flex-shrink-0 mt-0.5"/>
            Candidatos que demonstraram interesse nesta vaga serão notificados sobre as alterações realizadas.
          </div>

          <div className="flex gap-3 pt-1">
            <button onClick={onFechar} className="btn-outline flex-1 py-2.5 text-sm justify-center">Cancelar</button>
            <button onClick={() => onSalvar(form)} disabled={salvando}
              className="btn-primary flex-1 py-2.5 text-sm flex items-center justify-center gap-2 disabled:opacity-60">
              {salvando ? <Loader2 size={14} className="animate-spin"/> : <Save size={14}/>}
              Salvar e notificar candidatos
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Histórico de alterações ───────────────────────────────────
function PainelHistorico({ vagaId, onFechar }) {
  const [historico, setHistorico] = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    api.get(`/vagas/${vagaId}/historico`)
      .then(r => setHistorico(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [vagaId]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between p-5 border-b">
          <div className="flex items-center gap-2">
            <History size={16} className="text-acre-green"/>
            <p className="font-sora font-bold text-acre-dark">Histórico de Alterações</p>
          </div>
          <button onClick={onFechar} className="w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center">
            <X size={13}/>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">
          {loading ? (
            <div className="flex justify-center py-8"><Loader2 size={24} className="animate-spin text-acre-green"/></div>
          ) : historico.length === 0 ? (
            <div className="text-center py-8 text-gray-400">
              <History size={28} className="mx-auto mb-2 opacity-30"/>
              <p className="text-sm">Nenhuma alteração registrada ainda.</p>
            </div>
          ) : (
            <div className="space-y-3">
              {historico.map((h, i) => (
                <div key={i} className="bg-gray-50 border border-gray-100 rounded-xl p-3">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-xs font-bold text-acre-green bg-acre-green/10 px-2 py-0.5 rounded-full">{h.label}</span>
                    <span className="text-xs text-gray-400 flex items-center gap-1">
                      <Clock size={10}/>
                      {new Date(h.created_at).toLocaleString('pt-BR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' })}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-2 text-xs">
                    <div className="bg-red-50 border border-red-100 rounded-lg p-2">
                      <p className="text-gray-400 mb-0.5">Antes</p>
                      <p className="text-red-700 font-medium line-through">{h.valor_antes || '—'}</p>
                    </div>
                    <div className="bg-green-50 border border-green-100 rounded-lg p-2">
                      <p className="text-gray-400 mb-0.5">Depois</p>
                      <p className="text-green-700 font-medium">{h.valor_depois || '—'}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Página principal ──────────────────────────────────────────
export function GerenciarVagas() {
  const [vagas,    setVagas]    = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [editando, setEditando] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [historico,setHistorico]= useState(null);

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/vagas/empresa/minhas');
      setVagas(data);
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const salvarEdicao = async (form) => {
    setSalvando(true);
    try {
      await api.put(`/vagas/${editando.id}`, form);
      toast.success('✅ Vaga atualizada! Candidatos serão notificados.');
      setEditando(null);
      carregar();
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao salvar.');
    }
    setSalvando(false);
  };

  const alterarStatus = async (id, status) => {
    try {
      await api.put(`/vagas/${id}`, { status });
      setVagas(prev => prev.map(v => v.id === id ? {...v, status} : v));
      toast.success(status === 'aberta' ? 'Vaga reaberta!' : 'Vaga fechada.');
    } catch {
      toast.error('Erro ao alterar status.');
    }
  };

  const statusCor = {
    aberta:  'bg-green-100 text-green-700 border-green-200',
    pausada: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    fechada: 'bg-gray-100 text-gray-500 border-gray-200',
  };

  return (
    <Layout title="Minhas Vagas" subtitle="Gerencie suas oportunidades publicadas">

      {editando  && <ModalEditar vaga={editando} onSalvar={salvarEdicao} onFechar={() => setEditando(null)} salvando={salvando}/>}
      {historico && <PainelHistorico vagaId={historico} onFechar={() => setHistorico(null)}/>}

      <div className="flex justify-between items-center mb-5">
        <button onClick={carregar} className="p-2 rounded-lg border border-gray-200 text-gray-400 hover:text-acre-green hover:border-acre-green transition-colors">
          <RefreshCw size={14} className={loading ? 'animate-spin' : ''}/>
        </button>
        <Link to="/empresa/vagas/nova" className="btn-primary flex items-center gap-2 text-sm px-4 py-2.5">
          + Publicar Nova Vaga
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center py-16">
          <Loader2 size={28} className="animate-spin text-acre-green"/>
        </div>
      ) : vagas.length === 0 ? (
        <div className="card p-12 text-center">
          <p className="text-4xl mb-2">📋</p>
          <p className="text-gray-500 mb-3">Você ainda não publicou nenhuma vaga.</p>
          <Link to="/empresa/vagas/nova" className="btn-primary inline-flex items-center gap-2 text-sm px-5 py-2.5">
            + Publicar primeira vaga
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {vagas.map(v => (
            <div key={v.id} className="card p-5">
              <div className="flex items-start gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <h3 className="font-sora font-semibold text-acre-dark">{v.titulo}</h3>
                    <span className={`text-xs font-semibold border px-2 py-0.5 rounded-full ${statusCor[v.status] || 'bg-gray-100 text-gray-500 border-gray-200'}`}>
                      {v.status}
                    </span>
                  </div>
                  <p className="text-xs text-gray-400">
                    {v.cidade_vaga} · {v.quantidade} vaga(s) · {v.visualizacoes || 0} visualizações
                    {v.salario_min && ` · R$ ${Number(v.salario_min).toLocaleString('pt-BR')}`}
                  </p>
                  <div className="flex flex-wrap gap-1.5 mt-1.5">
                    {(v.areas_contratacao || []).map(a => (
                      <span key={a} className="badge-green text-xs">{a}</span>
                    ))}
                  </div>
                  {Number(v.total_matches) > 0 && (
                    <p className="text-xs text-acre-green font-semibold mt-1.5">
                      🎯 {v.total_matches} candidatos compatíveis · média {v.media_match}%
                    </p>
                  )}
                  <p className="text-xs text-gray-300 mt-1">
                    Publicada em {new Date(v.created_at).toLocaleDateString('pt-BR')}
                  </p>
                </div>

                {/* Ações */}
                <div className="flex flex-col gap-1.5 flex-shrink-0">
                  <Link to={`/empresa/match/${v.id}`}
                    className="btn-outline text-xs px-3 py-1.5 text-center">
                    🎯 Ver Matches
                  </Link>
                  <button onClick={() => setEditando(v)}
                    className="flex items-center justify-center gap-1.5 text-xs px-3 py-1.5 border border-blue-200 text-blue-600 hover:bg-blue-50 rounded-xl transition-colors">
                    <Pencil size={12}/> Editar
                  </button>
                  <button onClick={() => setHistorico(v.id)}
                    className="flex items-center justify-center gap-1.5 text-xs px-3 py-1.5 border border-gray-200 text-gray-500 hover:bg-gray-50 rounded-xl transition-colors">
                    <History size={12}/> Histórico
                  </button>
                  <button
                    onClick={() => alterarStatus(v.id, v.status === 'aberta' ? 'fechada' : 'aberta')}
                    className={`text-xs px-3 py-1.5 rounded-xl font-semibold border transition-all ${
                      v.status === 'aberta'
                        ? 'border-red-200 text-red-500 hover:bg-red-50'
                        : 'border-green-200 text-green-600 hover:bg-green-50'
                    }`}>
                    {v.status === 'aberta' ? 'Fechar' : 'Reabrir'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}

export default GerenciarVagas;
